/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

//Jacques Bega
//hook that grabs list of options associated with a given qid
import { QueryFunctionContext, useQuery } from '@tanstack/react-query';
import { fetchQIDList } from '../queryFunctions';

const useQIDListFullResponse = (token: string, qid: string) => {
  return useQuery({
    queryKey: [token, qid, 'qidList'],
    queryFn: ({ signal }: QueryFunctionContext) => fetchQIDList(signal, token, qid),
    refetchOnWindowFocus: false,
  });
};

export default useQIDListFullResponse;
